<template>
	<div></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "DynamicImagePluginConfig",
	setup() {
		return {};
	},
});
</script>
